const DISCLAIMER_TYPE_ORDER = ["Household Goods", "Bike", "Car", "Vehicles", "IT Supplies"];

export function getLRDisclaimer(loadDetails = []) {
  const selected = new Set();
  loadDetails.forEach(load => {
    const itemTypes = Array.isArray(load.item_types) ? load.item_types : [];
    if (itemTypes.includes("Household")) selected.add("Household Goods");
    if (itemTypes.includes("Vehicles")) {
      selected.add(["Bike", "Car"].includes(load.vehicle_item_type) ? load.vehicle_item_type : "Vehicles");
    }
    if (itemTypes.includes("IT Supplies")) selected.add("IT Supplies");
  });
  const itemTypes = DISCLAIMER_TYPE_ORDER.filter(itemType => selected.has(itemType));
  const effectiveTypes = itemTypes.length > 0 ? itemTypes : ["Household Goods"];

  let typeText = effectiveTypes[0];
  if (effectiveTypes.length === 2) {
    typeText = `${effectiveTypes[0]} and ${effectiveTypes[1]}`;
  } else if (effectiveTypes.length > 2) {
    typeText = `${effectiveTypes.slice(0, -1).join(", ")} and ${effectiveTypes[effectiveTypes.length - 1]}`;
  }

  return `Old and Used ${typeText} for personal use and not meant for Sale`;
}
